var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Quill from 'quill';
var embed = Quill.import('blots/embed');
var YouTubeAssetEmbed = /** @class */ (function (_super) {
    __extends(YouTubeAssetEmbed, _super);
    function YouTubeAssetEmbed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    YouTubeAssetEmbed.create = function (asset) {
        var node = _super.create.call(this);
        node.setAttribute('data-type', asset.type);
        node.setAttribute('data-id', "" + asset.id);
        // Styles to allow the scaling of the iframe
        node.style.position = 'relative';
        node.style.width = '100%';
        node.style.height = '0';
        node.style['padding-bottom'] = '56.25%';
        var vid = document.createElement('iframe');
        vid.setAttribute('src', asset.uri + "?modestbranding=1");
        vid.style.position = 'absolute';
        vid.style.width = '100%';
        vid.style.height = '100%';
        vid.style.top = '0';
        vid.style.left = '0';
        node.appendChild(vid);
        return node;
    };
    YouTubeAssetEmbed.blotName = 'YouTubeAssetEmbed';
    YouTubeAssetEmbed.className = 'ql-youtube-asset';
    YouTubeAssetEmbed.tagName = 'div';
    return YouTubeAssetEmbed;
}(embed));
export { YouTubeAssetEmbed };
